export default __webpack_public_path__ + "static/media/arrow-forward.608577d8.svg";